/*
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { ModuleWithProviders, NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';

import { EL_DATE_ADAPTER, ElDatepickerDirective } from './datepicker.directive';
import { ElOverlayModule } from '../cdk/overlay/overlay.module';
import { ElCalendarModule } from '../calendar/calendar.module';
import { ElCalendarComponent } from '../calendar/calendar.component';
import { ElDatepickerContainerComponent } from './datepicker-container.component';
import { ElDatepickerComponent, ElRangepickerComponent } from './datepicker.component';
import { ElCalendarRangeComponent } from '../calendar/calendar-range.component';
import { ElCalendarRangeModule } from '../calendar/calendar-range.module';
import { ElDateAdapterService, ElRangeAdapterService } from './datepicker-adapter';


@NgModule({
  imports: [ElOverlayModule, ElCalendarModule, ElCalendarRangeModule],
  exports: [ElDatepickerDirective, ElDatepickerComponent, ElRangepickerComponent],
  declarations: [ElDatepickerDirective, ElDatepickerContainerComponent, ElDatepickerComponent, ElRangepickerComponent],
  entryComponents: [ElCalendarComponent, ElCalendarRangeComponent, ElDatepickerContainerComponent],
})
export class ElDatepickerModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ElDatepickerModule,
      providers: [
        DatePipe,
        {
          provide: EL_DATE_ADAPTER,
          multi: true,
          useClass: ElDateAdapterService,
        },
        {
          provide: EL_DATE_ADAPTER,
          multi: true,
          useClass: ElRangeAdapterService,
        },
      ],
    };
  }
}
